import { render, staticRenderFns } from "./remove-competition-confirm.vue?vue&type=template&id=3990581b&"
import script from "./remove-competition-confirm.vue?vue&type=script&lang=js&"
export * from "./remove-competition-confirm.vue?vue&type=script&lang=js&"
import style0 from "./remove-competition-confirm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports